import { Checkbox as FluentCheckbox, ICheckboxProps, ICheckboxStyles } from "@fluentui/react";
import React from "react";

export type CheckboxProps = ICheckboxProps & {
    testId?: string;
};

export const Checkbox: React.FunctionComponent<CheckboxProps> = (props: CheckboxProps) => {
    return (
        <FluentCheckbox
            {...props}
            styles={props.styles || defaultCheckboxStyle}
            inputProps={{ "data-testid": props.testId } as Record<string, unknown>}
        />
    );
};

const defaultCheckboxStyle: ICheckboxStyles = {
    root: {
        padding: 5
    }
};
